"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.duplicateLocation = exports.deleteLocation = exports.editLocation = exports.addLocation = exports.initialLocations = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var uuid_1 = require("uuid");
var characterSlices_1 = require("./characterSlices");
var gddSlice_1 = require("./gddSlice");
var initialState = {
    locations: [],
};
var locationsSlice = (0, toolkit_1.createSlice)({
    name: "locations",
    initialState: initialState,
    reducers: {
        addLocation: function (state, action) {
            state.locations.push(action.payload);
        },
        editLocation: function (state, action) {
            var index = state.locations.findIndex(function (location) { return location.id === action.payload.id; });
            if (index === -1)
                return;
            state.locations[index] = __assign(__assign({}, state.locations[index]), action.payload);
        },
        deleteLocation: function (state, action) {
            state.locations = state.locations.filter(function (location) { return location.id !== action.payload; });
        },
        duplicateLocation: function (state, action) {
            var dup = __assign(__assign({}, action.payload), { id: (0, uuid_1.v4)() });
            state.locations.push(dup);
        },
    },
    extraReducers: function (builder) {
        builder.addCase(characterSlices_1.deleteCharacter, function (state, action) {
            state.locations = state.locations.map(function (location) { return (__assign(__assign({}, location), { characters: location.characters.filter(function (characterId) { return characterId !== action.payload; }) })); });
        });
        builder.addCase(gddSlice_1.closeGDD, function () {
            return initialState;
        });
    },
});
exports.initialLocations = locationsSlice.getInitialState();
exports.addLocation = (_a = locationsSlice.actions, _a.addLocation), exports.editLocation = _a.editLocation, exports.deleteLocation = _a.deleteLocation, exports.duplicateLocation = _a.duplicateLocation;
exports.default = locationsSlice.reducer;
